import { useEffect, useState } from 'react';

interface IUsePLayerOptions {
  plugins?: {
    VideoIdPlugin?: {
      getPlayToken: Function;
    };
  };
}

/**
 * 标准播放播放器
 * @returns
 */
const useStreamLakePlayer = (options?: IUsePLayerOptions) => {
  const [player, setPlayer] = useState(null);

  useEffect(() => {
    if (process.browser) {
      const loadPlayer = async () => {
        const { default: players } = await import('@streamlake/web-player');
        const { StreamLakePlayerReact } = players;
        setPlayer(StreamLakePlayerReact);
      };
      loadPlayer();
    }
  }, []);

  return player;
};
export default useStreamLakePlayer;
